import React from 'react';
import FooterHero from '../../component/common/CTA'
import HeroSection from '../../component/common/hero'
import HowWeHelp from '../../component/common/howWeHelp'
import CaseStudySlider from '../../component/common/caseStudy'
import { Helmet } from 'react-helmet-async';

const caseStudiesData = [
  {
    image: "img/logos/whizdom.png", // Replace with actual image URL
    heading: "Whizdom Club",
    content:
      "TurningIdeas Ventures partnered with Whizdom Club India, a venture by Magnolia Quality Development Corporation (MQDC) Thailand, to establish and scale their premium innovation and coworking space in India. We provided end-to-end market entry strategy, brand positioning, and community-building initiatives, ensuring a seamless launch in the highly competitive Indian market. From curating startup engagement programs to driving occupancy growth and partnerships, we played a key role in positioning Whizdom Club as a hub for entrepreneurs, innovators, and creatives. Our expertise in business acceleration and corporate innovation helped Whizdom India achieve rapid traction and a strong foothold in the ecosystem. 🚀",
    link: "https://www.whizdomindia.com/",
  },
  {
    image: "img/logos/dalmia.png",
    heading: "Dalmia Bharat",
    content:
      "Dalmia Bharat faced a critical challenge—reducing their order-to-delivery cycle from 7 days to just 24 hours. TurningIdeas stepped in to identify, match, and co-create a solution by connecting them with TurningCloud Technologies, an innovative tech startup. Together, we developed mSuvidha, a mobile app that streamlined dealer ordering, improved supply chain efficiency, and enhanced real-time order tracking. This collaboration not only cut delivery times drastically but also boosted dealer engagement and revenue growth for Dalmia Bharat, showcasing the power of startup-enterprise innovation.",
    link: "https://www.dalmiabharat.com/",
  },
];

const heroData = {
  title: {
    bold: "Global",
    light: "Startups",
  },
  subtitle: "Expand in India with Confidence",
  description: {
    heading: "Entering India's Market? We Make It Seamless.",
    intro: "India is one of the fastest-growing markets, but",
    outro: "can be complex. We simplify it for you."
  },
  highlightedText: "navigating regulations, finding the right partners, and scaling effectively",
  heroImage: "img/global-hero.png",
  bgImg: "img/global-hero-bg.png",
  btnText: "Expand in India",
  btnLink: "https://forms.gle/MAgquUKQDY4k9gjH8"
};


const serviceCards = [
  {
    title: "Market Research & Localization",
    text: "Understanding Indian consumers & competition.",
    subtext: "",
    iconLink: "img/global-help1.png" // Target icon
  },
  {
    title: "Regulatory & Compliance Support",
    text: "Helping you comply with local laws.",
    subtext: "",
    iconLink: "img/global-help2.png"
  },
  {
    title: "Business Development & Sales",
    text: "Connecting you with customers & distributors.",
    subtext: "",
    iconLink: "img/global-help3.png" // Growth chart icon
  },
  {
    title: "Strategic Partnerships & Fundraising",
    text: "Enabling faster growth through investor & enterprise connections.",
    subtext: "",
    iconLink: "img/global-help4.png" // Rocket icon
  }
];

const statsDataHeading = {
  light: "Why Expand in",
  bold: "India?"
}

const statsData = [
  {
    title: "$3.5 Trillion Economy",
    text: "Rapid digital adoption & growing middle class."
  },
  {
    title: "Largest Startup Ecosystem in Asia",
    text: "100K+ startups & rising investment."
  },
  {
    title: "Massive Untapped Market",
    text: "Over 1.4 billion consumers"
  }
];

const worldMapImg = "img/why-global.png";


const headerData = {
  title: "How We Help",
  highlightedText: "International",
  normalText: "Startups",
  description: "From idea to exit, together. when we partner with founders, we're all in combining expertise, empathy, embedded resources, and capital to build breakout companies",
  imgLink: "img/help-global.png"
};

const GlobalPage = () => {
  return (
    <div>

      <Helmet>
        <title>Expand Your Startup in India & Asia | Market Entry & Growth Support</title>
        <meta name="description" content="TurningIdeas helps global startups expand in India & Asia with market entry support, GTM strategy, regulatory compliance, partnerships, and cost-effective product development." />
        <meta name="keywords" content="expand startup in India, global startup market entry, India business expansion, startup growth in Asia, scale business in India, India startup ecosystem, global startup funding, product localization, regulatory support India, GTM strategy India, international startup accelerator, global business development, tech startup expansion, India VC funding, India business partnerships, startup innovation India" />
      </Helmet>


      <HeroSection
        title={heroData.title}
        subtitle={heroData.subtitle}
        description={heroData.description}
        highlightedText={heroData.highlightedText}
        callToAction={heroData.callToAction}
        heroImage={heroData.heroImage}
        bgImg={heroData.bgImg}
        btnText={heroData.btnText}
        btnLink={heroData.btnLink}
      />


      <section className="py-6 md:py-12">
        <div className="container mx-auto px-6 md:px-12">
          <HowWeHelp
            headerData={headerData}
            serviceCards={serviceCards}
            statsDataHeading={statsDataHeading}
            statsData={statsData}
            worldMapImg={worldMapImg}
          />                </div>
      </section>

      <section className="py-6 md:py-12 bg-black">
        <div className="container mx-auto px-6 md:px-12">
          <CaseStudySlider caseStudies={caseStudiesData} />
        </div>
      </section>

      <FooterHero
        heading="Let’s Build Together"
        subheading="Join the TurningIdeas Ecosystem"
        paragraph="Whether you're a startup, investor, or enterprise, we help you scale, innovate, and succeed."
        buttonText="Contact Us Today!"
      />
    </div>
  );
};

export default GlobalPage;
